module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-3 px-2 py-0 kios-item"
  }, [_c('div', {
    staticClass: "wrap-scroll px-2 py-2",
    class: _vm.votingItems.length > 2 ? 'wrap-scroll-votting' : ''
  }, _vm._l((_vm.votingItems), function(item, index) {
    return (_vm.votingItems.length > 0) ? _c('div', {
      key: index,
      class: _vm.visible ? 'overlayActive' : ''
    }, [_c('div', {
      staticClass: "text-bold"
    }, [_vm._v("\n        " + _vm._s(index + 1) + ".  " + _vm._s(item.subject) + "\n      ")]), _vm._v(" "), _c('v-radio-group', {
      staticClass: "ml-3 pt-2",
      attrs: {
        "row": ""
      },
      model: {
        value: (item.selected),
        callback: function($$v) {
          _vm.$set(item, "selected", $$v)
        },
        expression: "item.selected"
      }
    }, _vm._l((item.choices), function(item1, index1) {
      return _c('v-radio', {
        key: index1,
        attrs: {
          "label": item1,
          "value": index1 + 1
        }
      })
    }), 1), _vm._v(" "), _c('v-layout', {
      staticClass: "ml-3",
      staticStyle: {
        "margin-top": "-10px"
      },
      attrs: {
        "wrap": ""
      }
    }, _vm._l((item.answers), function(item2, index2) {
      return _c('v-flex', {
        key: index2,
        staticStyle: {
          "margin-left": "45px"
        }
      }, [_c('span', {
        staticClass: "text-bold",
        staticStyle: {
          "color": "green"
        }
      }, [_vm._v(_vm._s(item2) + "/" + _vm._s(item.answersCount))])])
    }), 1)], 1) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    class: _vm.visible ? 'validDanhGiaCLDV' : ''
  }, [(!_vm.isSigned && _vm.votingItems.length > 0) ? _c('v-layout', {
    staticClass: "mt-4",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pr-3",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('div', {
    staticClass: "text-bold",
    staticStyle: {
      "width": "110px"
    }
  }, [_vm._v("Mã hồ sơ "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "pt-0 input-border input-group input-group--placeholder input-group--text-field primary--text",
    staticStyle: {
      "width": "calc(100%-110px)"
    }
  }, [_c('div', {
    staticClass: "input-group__input"
  }, [_c('input', {
    staticClass: "kios-input",
    attrs: {
      "id": "dossierIdNoKey",
      "data-layout": "normal",
      "aria-label": "Số CMND",
      "placeholder": "Nhấn để nhập mã hồ sơ",
      "type": "text"
    },
    on: {
      "focus": _vm.show
    }
  }), _vm._v(" "), (_vm.visible) ? _c('i', {
    staticClass: "icon material-icons input-group__append-icon input-group__icon-cb input-group__icon-clearable",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.clear('dossierIdNoKey')
      }
    }
  }, [_vm._v("clear")]) : _vm._e()]), _vm._v(" "), (!_vm.validPass1) ? _c('div', {
    staticClass: "mt-2"
  }, [_c('div', {
    staticClass: "input-group__messages",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Mã hồ sơ là bắt buộc")])]) : _vm._e()])])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-3",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('div', {
    staticClass: "text-bold",
    staticStyle: {
      "width": "110px"
    }
  }, [_vm._v("Số CMND "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "pt-0 input-border input-group input-group--placeholder input-group--text-field primary--text",
    staticStyle: {
      "width": "calc(100%-110px)"
    }
  }, [_c('div', {
    staticClass: "input-group__input"
  }, [_c('input', {
    staticClass: "kios-input",
    attrs: {
      "id": "applicantIdNo",
      "data-layout": "normal",
      "aria-label": "Số CMND",
      "placeholder": "Nhấn để nhập số CMND",
      "type": "text"
    },
    on: {
      "focus": _vm.show
    }
  }), _vm._v(" "), (_vm.visible) ? _c('i', {
    staticClass: "icon material-icons input-group__append-icon input-group__icon-cb input-group__icon-clearable",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.clear('applicantIdNo')
      }
    }
  }, [_vm._v("clear")]) : _vm._e()]), _vm._v(" "), (!_vm.validPass2) ? _c('div', {
    staticClass: "mt-2"
  }, [_c('div', {
    staticClass: "input-group__messages",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Số CMND là bắt buộc")])]) : _vm._e()])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center mt-4"
  }, [_c('v-btn', {
    staticClass: "kios-btn",
    attrs: {
      "color": "primary",
      "loading": _vm.loadingAction,
      "disabled": _vm.loadingAction
    },
    on: {
      "click": _vm.submitVoting
    }
  }, [_vm._v("Gửi kết quả")])], 1)], 1), _vm._v(" "), (_vm.votingItems.length > 0) ? _c('v-btn', {
    staticClass: "back-btn",
    attrs: {
      "fab": "",
      "color": "primary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("arrow_back")])], 1) : _vm._e(), _vm._v(" "), (_vm.visible) ? _c('div', {
    staticClass: "virtual-keyboard"
  }, [(_vm.visible) ? _c('vue-touch-keyboard', {
    attrs: {
      "layout": _vm.layout,
      "cancel": _vm.hide,
      "accept": _vm.accept,
      "input": _vm.input,
      "next": _vm.next
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-632aa9ac", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-632aa9ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChiTietDanhGiaCLDV.vue
// module id = 530
// module chunks = 1